module.exports = __webpack_public_path__ + "static/img/canshubiao.8fee9ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/canshubiao.png
// module id = Q2ar
// module chunks = 2